var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styles from "./HeatmapTitle.module.scss";
import { useParams } from "react-router-dom";
import { useGetSingleAvailableCohortReportsQuery } from "../../store/api/core";
var By = function () {
    var _a;
    var reportId = useParams().reportId;
    var data = useGetSingleAvailableCohortReportsQuery({ reportId: reportId || "" }, { shouldSkipCall: function () { return !reportId; } });
    if (!(data === null || data === void 0 ? void 0 : data.data)) {
        return "";
    }
    var _b = ((_a = data.data) === null || _a === void 0 ? void 0 : _a.heatmapLabels) || {}, xAxis = _b.xAxis, yAxis = _b.yAxis;
    return " by ".concat(xAxis, " and ").concat(yAxis);
};
export var HeatmapTitle = function (_a) {
    var title = _a.title, legendImageItems = _a.legendImageItems;
    return (_jsxs("div", __assign({ className: styles.heatmapTitleRoot }, { children: [_jsxs("div", __assign({ className: styles.heatmapTitleText }, { children: [title, _jsx(By, {})] })), legendImageItems && legendImageItems.length > 0 && (_jsx("div", __assign({ className: styles.heatmapLegendImages }, { children: legendImageItems.map(function (_a) {
                    var key = _a.key, src = _a.src, alt = _a.alt, label = _a.label, className = _a.className;
                    return (_jsxs("div", __assign({ className: styles.heatmapLegendImageItem }, { children: [_jsx("img", { src: src, alt: alt, className: className
                                    ? "".concat(className, " ").concat(styles.heatmapLegendImg)
                                    : styles.heatmapLegendImg }), label && (_jsx("span", __assign({ className: styles.heatmapLegendLabel }, { children: label })))] }), key));
                }) })))] })));
};
